import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputField from '../../form/InputField';
import FileUpload from '../../form/FileUpload';
import { useUpdateResource } from '../../../hooks/useUpdateResource';
import LoadingButton from '../../form/LoadingButton';
import SubmitButton from '../../form/SubmitButton';
import { toInputDateTimeLocal } from '../../../utils/toInputDateTimeLocal';

export interface GiftTemplateFormData {
  endDate: string | null;
  startDate: string | null;
  imageurl:string
}

interface UpdateGiftTemplateFormProps {
  id: number;
  defaultValues: GiftTemplateFormData;
  onSubmitSuccess:()=>void
}

function UpdateGiftTemplateForm({ id, defaultValues,onSubmitSuccess }: UpdateGiftTemplateFormProps) {
  const { t } = useTranslation();
  const { register, handleSubmit, watch, formState: { errors } } = useForm<GiftTemplateFormData>({
    defaultValues: {
    startDate: toInputDateTimeLocal(defaultValues.startDate??"") ?? "",
    endDate:   toInputDateTimeLocal(defaultValues.endDate??"")  ?? ""
  }
  });

  const [image, setImage] = useState<File | null>(null);

  const start = watch("startDate");

  const {loading,updateResource} = useUpdateResource();
      
        const onSubmit: SubmitHandler<GiftTemplateFormData> = async (data) => {
            const formData = new FormData();
            if(data.startDate){
              console.log(new Date( data.startDate).toISOString());
                formData.append('startDate',new Date( data.startDate).toISOString())
            }
            if(data.endDate){
                formData.append('endDate',new Date( data.endDate).toISOString())
            }
            if(image){
                formData.append('image',image)
            }
            await  updateResource(`gift-template/${id}`, formData, "admin",{
                method: "PUT",
                successMessage: t("update_success"),
                invalidateQueries:["gift-tepmpaltes-bycatgeory-by-admin"],
                });
            if (onSubmitSuccess) onSubmitSuccess();
    };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        {/* Start Date */}
        <InputField
          placeholder=""
          label={t("startDate")}
          register={register("startDate")}
          type="datetime-local"
          error={errors.startDate}
        />

        {/* End Date */}
        <InputField
          placeholder=""
          label={t("endDate")}
          register={register("endDate", {
            validate: (value) =>
              !value || !start || new Date(value) > new Date(start) || t("endDate_must_be_after_startDate")
          })}
          type="datetime-local"
          error={errors.endDate}
        />
      </div>

      {/* Image Upload */}
      <FileUpload
        file={image}
        setFile={setImage}
        label=""
        addText={t("add_image")}
        shape="rectangle"
        size={200}
        initial={defaultValues.imageurl}
      />

      {
        loading
        ?
        <LoadingButton/>
        :
        <SubmitButton label={t("update")}/>
    }
    </form>
  );
}

export default UpdateGiftTemplateForm;
